










































import { Vue, Component, Prop } from "vue-property-decorator";
import { Test, Tests } from "../../types/TrialPitTests";

export interface TrialPitTestModel {
  testType: Test;
  distanceFromWall: number;
  depthOfSample: number;
  testResults: string;
}

@Component({})
export default class TrialPitTest extends Vue {
  @Prop({ default: () => ({}) }) private test!: TrialPitTestModel;

  private tests = Tests;

  private testChanged() {
    this.$emit("testChanged");
  }
}
